import { createSelector, createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentUser: null,
};
const EMPTY_GOOGLE_ACCOUNTS = [];

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setCurrentUser: (state, action) => {
      console.log("📝 setCurrentUser called with payload:", action.payload);
      return {
        ...state,
        currentUser: action.payload,
      };
    },
    setSchool: (state, action) => {
      console.log("🏫 setSchool called with:", action.payload);
      if (!state.currentUser) return state;

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          school: action.payload,
        },
      };
    },
    setOnboardingStatus: (state, action) => {
      console.log("📋 setOnboardingStatus called with:", action.payload);
      if (!state.currentUser) return state;

      const { completed, skipped } = action.payload;
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          onboardingCompleted: completed !== undefined ? completed : state.currentUser.onboardingCompleted,
          onboardingSkipped: skipped !== undefined ? skipped : state.currentUser.onboardingSkipped,
        },
      };
    },
    addGoogleAccount: (state, action) => {
      console.log("➕ addGoogleAccount called with:", action.payload);
      if (!state.currentUser) return state;

      const googleAccounts = state.currentUser.googleAccounts || [];
      const existingIndex = googleAccounts.findIndex(
        account => account.email === action.payload.email
      );

      let updatedAccounts;
      if (existingIndex >= 0) {
        // Update existing account
        updatedAccounts = [...googleAccounts];
        updatedAccounts[existingIndex] = {
          ...updatedAccounts[existingIndex],
          ...action.payload,
        };
      } else {
        // Add new account
        updatedAccounts = [...googleAccounts, action.payload];
      }

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          googleAccounts: updatedAccounts,
          // Keep backward compatibility - set primary account as default
          googleAccessToken: updatedAccounts[0]?.accessToken || null,
          driveEnabled: updatedAccounts.length > 0,
        },
      };
    },
    removeGoogleAccount: (state, action) => {
      console.log("➖ removeGoogleAccount called with email:", action.payload);
      if (!state.currentUser) return state;

      const googleAccounts = state.currentUser.googleAccounts || [];
      const updatedAccounts = googleAccounts.filter(
        account => account.email !== action.payload
      );

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          googleAccounts: updatedAccounts,
          googleAccessToken: updatedAccounts[0]?.accessToken || null,
          driveEnabled: updatedAccounts.length > 0,
        },
      };
    },
  },
});

export const userReducer = userSlice.reducer;
export const {
  setCurrentUser,
  setSchool,
  setOnboardingStatus,
  addGoogleAccount,
  removeGoogleAccount
} = userSlice.actions;

export const selectCurrentUser = (state) => {
  return state.user.currentUser;
};

export const selectGoogleAccounts = (state) => {
  return state.user.currentUser?.googleAccounts || EMPTY_GOOGLE_ACCOUNTS;
};

export const selectSchool = (state) => {
  return state.user.currentUser?.school || null;
};

export const selectOnboardingStatus = createSelector(
  [selectCurrentUser],
  (user) => ({
    completed: Boolean(user?.onboardingCompleted),
    skipped: Boolean(user?.onboardingSkipped),
  })
);

export const selectNeedsOnboarding = (state) => {
  const user = state.user.currentUser;
  if (!user) return false;
  // Show onboarding if user has no school and hasn't completed or skipped onboarding
  return !user.school && !user.onboardingCompleted && !user.onboardingSkipped;
};
